import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Lp02to04::FloatingCta::Component の Stimulus コントローラ。
// landIeul: スクロール量が onset〜offset の範囲で fadeIn し、その間だけ CTA リンクを描画する。
// しきい値は isSp (max-width:767) で切替 (SP: 750〜6000 / PC: 625〜3900)。
const CTA_ACTION_LINK = "/plan-request/";

class SiteLp02to04FloatingCtaController extends Controller {
  static targets = ["contents"];
  static values = { prefix: String };

  declare readonly contentsTarget: HTMLElement;
  declare readonly prefixValue: string;

  private link: HTMLAnchorElement | null = null;
  private handler = () => this.onScroll();

  connect(): void {
    window.addEventListener("scroll", this.handler);
    this.onScroll();
  }

  disconnect(): void {
    window.removeEventListener("scroll", this.handler);
  }

  private onScroll(): void {
    const isSp = window.matchMedia("(max-width: 767px)").matches;
    const onset = isSp ? 750 : 625;
    const offset = isSp ? 6000 : 3900;
    const y = window.pageYOffset;
    const fadeIn = y > onset && y <= offset;
    this.element.classList.toggle(`${this.prefixValue}_fadeIn`, fadeIn);
    this.toggleLink(fadeIn);
  }

  private toggleLink(show: boolean): void {
    if (show && !this.link) {
      const search = window.location.search;
      const href = search
        ? `${CTA_ACTION_LINK}${search}&utm_campaign=LP_floating`
        : `${CTA_ACTION_LINK}?utm_campaign=LP_floating`;
      const a = document.createElement("a");
      a.className = `${this.prefixValue}_areaCtaLink`;
      a.target = "_blank";
      a.rel = "nofollow";
      a.href = href;
      const btn = document.createElement("div");
      btn.className = `${this.prefixValue}_areaCtaBtn`;
      btn.id = "lpFloatingCta";
      a.appendChild(btn);
      this.contentsTarget.appendChild(a);
      this.link = a;
    } else if (!show && this.link) {
      this.link.remove();
      this.link = null;
    }
  }
}

application.register("site--lp02to04--floating-cta", SiteLp02to04FloatingCtaController);
